import React, { useState } from 'react';
import i18n from 'i18next';
import '@inertiajs/inertia-react';
import MyBillingSlider from './MyBillingSlider';
import { FileUploadArea } from '@/Components/FileUploadArea';
import MyModuleCard from '@/Components/Manage/MyModuleCard';
import {Link, usePage} from "@inertiajs/inertia-react";
import {Inertia} from "@inertiajs/inertia";

export default function OrganizationAccount() {
    let organization = usePage().props.organization;
    const assetDomain = usePage().props.assetDomain;
    const modules = usePage().props.modules;
    let defaultState = {
        showTrialAlert: null,
        showUpgradeToday: false,
        myBilling: false,
        logo: usePage().props.organization.logo_url
    };

    let [state, setState] = useState(defaultState);

    const toggleMyBilling = () => {
        setState({...state, showMyBilling: !state.showMyBilling});
    }

    /*
    const toggleUpgradeToday = () => {
        setState({...state, showUpgradeToday: !state.showUpgradeToday});
    }

    function hideTrialAlert () {
        setState({...state, showTrialAlert: null});
    }
    */

    function onFileUploaded(data) {
        setState((state) => ({...state, logo: `${assetDomain}/${data.key}`}));
        Inertia.post(
            route('manage.organization.logo.store'),
            data
        )
    }

    return (
        <div className="organization-account">
            {/*
            <div className="row">
                <div className="col-12 text-center trial-ends">
                    <span>{i18n.t("organization-account.your-trial-ends-in")} 29 {i18n.t("organization-account.days")}</span>
                    <div onClick={() => toggleUpgradeToday()} className="btn btn-sm btn-primary">Upgrade Today</div>
                </div>
            </div>
            */}
            <div className="row">
                <div className="col-12 col-sm-6 mb-card">
                    <div className="mb-card-container">
                        <div className="mb-card-header">
                            {i18n.t("organization-account.logo")}
                        </div>
                        <div className="mb-card-body">
                            {state.logo &&
                                <div className="logo-container">
                                    <div className="logo"><img src={state.logo} alt={`${organization.name} logo`}/></div>
                                    <Link
                                        as="button"
                                        method="DELETE"
                                        href={route('manage.organization.logo.destroy')}
                                        className="btn btn-link delete"
                                        onSuccess={() => setState({...state, logo: null})}
                                    >
                                        <span><i className="fas fa-trash"></i></span>
                                    </Link>
                                </div>
                            }
                            <FileUploadArea
                                onUploaded={onFileUploaded}
                                showUploader={true}
                                dropText={i18n.t("organization-account.drag-or-drop")}
                                browseText={i18n.t("organization-account.choose-file")}
                                instructions={i18n.t("organization-account.logo-info")} />
                            </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 mb-card">
                    <div className="mb-card-container">
                        <div className="mb-card-header">
                            {i18n.t("organization-account.billing")}
                        </div>
                        <div className="mb-card-body billing text-center">
                            <div className="info">
                                <span>{organization?.owner?.first_name + " " + organization?.owner?.last_name}<br/></span>
                                {organization.address?.line_1 && <span>{organization.address.line_1}<br/></span>}
                                {organization.address?.line_2 && <span>{organization.address.line_2}<br/></span>}
                                {organization.address?.city && <span>{organization.address.city}</span>}
                                {organization.address?.city && organization.address.state && <>, </>}
                                {organization.address?.city && organization.address.state && <span>{organization.address.state}</span>}
                                {organization.address?.postal_code && <span> {organization.address.postal_code}</span>}
                                {organization.address?.country_code && <span> {organization.address.country_code.toUpperCase()}</span>}
                            </div>
                            <div className="btn btn-outline-secondary" onClick={() => {toggleMyBilling()}}>{i18n.t("organization-account.edit-address")}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 mb-card">
                    <div className="mb-card-container">
                        <div className="mb-card-header">
                            {i18n.t("organization-account.my-applications")}
                        </div>
                        <div className="mb-card-body my-applications">
                            {modules.active.map((module, index) =>
                                <MyModuleCard key={index} module={module} isActive={true} />
                            )}
                            {modules.inactive.map((module, index) =>
                                <MyModuleCard key={index} module={module} isActive={false}/>
                            )}
                            {/*
                            <div className="col-12 col-sm-6 module-container more-modules">
                                <div className="more text-center">
                                    <a href="/" target="_blank" className="no-link">
                                        <span>{i18n.t("organization-account.more-ways")}</span>
                                        <i className="fas fa-external-link"></i>
                                    </a>
                                </div>
                            </div>
                            */}
                        </div>
                    </div>
                </div>
            </div>
            <MyBillingSlider show={state.showMyBilling} auth={usePage().props.auth} organization={organization} toggleMyBilling={toggleMyBilling} />
            {/*
                {state.showTrialAlert &&
                    <div className="trial-alert">
                        <i className="fas fa-check"></i>
                        <span>
                            "<div dangerouslySetInnerHTML={{__html: state.showTrialAlert}} />" {i18n.t("organization-account.has-been-added")}
                        </span>
                        <i onClick={() => hideTrialAlert()} className="fa fa-times"></i>
                    </div>
                }
            */}
            {/*<UpgradeTodayModal show={state.showUpgradeToday} onHide={() => toggleUpgradeToday()} />*/}
        </div>
    );
}
